module.exports = __webpack_public_path__ + "img/QV.eda3589b.png";